import { CalendarDate } from '@internationalized/date'
import { AlmanacFileCalendarEvent } from '../types'
import dayjs from 'dayjs'
import { CalendarState } from '@react-stately/calendar'

export const LAST_VIEWED_WEEK_KEY = 'last_viewed_week'
export const DEFAULT_LOADING_COLOR = '#96cbee4d'
const LOADING_COLORS_KEY = 'loading-colors'

export const groupBy = (list: AlmanacFileCalendarEvent[], criteria: (item: AlmanacFileCalendarEvent) => string) => {
  return list.reduce((prev, curr) => {
    const group = criteria(curr)
    if (!prev[group]) {
      prev[group] = []
    }
    prev[group].push(curr)
    return prev
  }, {} as Record<string, AlmanacFileCalendarEvent[]>)
}

export const formatDate = (date: CalendarDate, state: CalendarState) => {
  return dayjs(date.toDate(state.timeZone)).format('YYYY-MM-DD')
}

export const getLoadingColor = (event: AlmanacFileCalendarEvent, colors: string[]) => {
  if (!event.scheduleContentId && !event.key) {
    return DEFAULT_LOADING_COLOR
  }

  const colorsMap = JSON.parse(localStorage.getItem(LOADING_COLORS_KEY) || '{}')

  if (event.scheduleContentId && !event.key) {
    const existingColor = colorsMap[event.scheduleContentId?.toString()]

    if (existingColor) return existingColor

    const newColor = getLoadingColorFromId(event, colors)
    colorsMap[event.scheduleContentId?.toString()] = newColor
    localStorage.setItem(LOADING_COLORS_KEY, JSON.stringify(colorsMap))

    return newColor
  }

  if (event.key && !event.scheduleContentId) {
    const existingColor = colorsMap[event.key]

    if (existingColor) return existingColor

    const newColor = getLoadingColorFromId(event, colors)
    colorsMap[event.key] = newColor
    localStorage.setItem(LOADING_COLORS_KEY, JSON.stringify(colorsMap))

    return newColor
  }

  if (event.scheduleContentId && event.key) {
    const colorFromContentId = colorsMap[event.scheduleContentId?.toString()]
    const colorFromKey = colorsMap[event.key]

    if (colorFromContentId || colorFromKey) {
      const color = colorFromContentId || colorFromKey
      colorsMap[event.key] = color
      colorsMap[event.scheduleContentId?.toString()] = color
      localStorage.setItem(LOADING_COLORS_KEY, JSON.stringify(colorsMap))

      return color
    }

    const newColor = getLoadingColorFromId(event, colors)
    colorsMap[event.scheduleContentId?.toString()] = newColor
    colorsMap[event.key] = newColor
    localStorage.setItem(LOADING_COLORS_KEY, JSON.stringify(colorsMap))

    return newColor
  }

  return DEFAULT_LOADING_COLOR
}

const getLoadingColorFromId = (event: AlmanacFileCalendarEvent, colors: string[]) => {
  let lastChar = event.scheduleContentId?.toString().slice(-1)
  if (!lastChar) lastChar = event.key?.slice(-1)?.toLowerCase()

  const isDigit = !isNaN(Number(lastChar))
  const index = isDigit ? parseInt(lastChar || '0') : lastChar?.charCodeAt(0) - 'a'.charCodeAt(0) || 0

  return colors[index % colors.length] || DEFAULT_LOADING_COLOR
}

export const updateLastViewedWeek = (date: string, projectKey: string = 'workspace') => {
  const d = dayjs(date)
  if (!d.isValid()) return
  localStorage.setItem(`${LAST_VIEWED_WEEK_KEY}_${projectKey}`, d.format('YYYY-MM-DD'))
}
